/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.SystemMessageFilter = (function() {

    /**
     * Namespace SystemMessageFilter.
     * @exports SystemMessageFilter
     * @namespace
     */
    var SystemMessageFilter = {};

    SystemMessageFilter.SystemMessageFilterModel = (function() {

        /**
         * Properties of a SystemMessageFilterModel.
         * @memberof SystemMessageFilter
         * @interface ISystemMessageFilterModel
         * @property {string|null} [sortColumn] SystemMessageFilterModel sortColumn
         * @property {string|null} [sortOrder] SystemMessageFilterModel sortOrder
         * @property {number|null} [pageIndex] SystemMessageFilterModel pageIndex
         * @property {number|null} [pageSize] SystemMessageFilterModel pageSize
         */

        /**
         * Constructs a new SystemMessageFilterModel.
         * @memberof SystemMessageFilter
         * @classdesc Represents a SystemMessageFilterModel.
         * @implements ISystemMessageFilterModel
         * @constructor
         * @param {SystemMessageFilter.ISystemMessageFilterModel=} [p] Properties to set
         */
        function SystemMessageFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SystemMessageFilterModel sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof SystemMessageFilter.SystemMessageFilterModel
         * @instance
         */
        SystemMessageFilterModel.prototype.sortColumn = null;

        /**
         * SystemMessageFilterModel sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof SystemMessageFilter.SystemMessageFilterModel
         * @instance
         */
        SystemMessageFilterModel.prototype.sortOrder = null;

        /**
         * SystemMessageFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof SystemMessageFilter.SystemMessageFilterModel
         * @instance
         */
        SystemMessageFilterModel.prototype.pageIndex = null;

        /**
         * SystemMessageFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof SystemMessageFilter.SystemMessageFilterModel
         * @instance
         */
        SystemMessageFilterModel.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * SystemMessageFilterModel _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof SystemMessageFilter.SystemMessageFilterModel
         * @instance
         */
        Object.defineProperty(SystemMessageFilterModel.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * SystemMessageFilterModel _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof SystemMessageFilter.SystemMessageFilterModel
         * @instance
         */
        Object.defineProperty(SystemMessageFilterModel.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * SystemMessageFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof SystemMessageFilter.SystemMessageFilterModel
         * @instance
         */
        Object.defineProperty(SystemMessageFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * SystemMessageFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof SystemMessageFilter.SystemMessageFilterModel
         * @instance
         */
        Object.defineProperty(SystemMessageFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified SystemMessageFilterModel message. Does not implicitly {@link SystemMessageFilter.SystemMessageFilterModel.verify|verify} messages.
         * @function encode
         * @memberof SystemMessageFilter.SystemMessageFilterModel
         * @static
         * @param {SystemMessageFilter.ISystemMessageFilterModel} m SystemMessageFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SystemMessageFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(10).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(18).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(24).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(32).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified SystemMessageFilterModel message, length delimited. Does not implicitly {@link SystemMessageFilter.SystemMessageFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof SystemMessageFilter.SystemMessageFilterModel
         * @static
         * @param {SystemMessageFilter.ISystemMessageFilterModel} message SystemMessageFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SystemMessageFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SystemMessageFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof SystemMessageFilter.SystemMessageFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {SystemMessageFilter.SystemMessageFilterModel} SystemMessageFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SystemMessageFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.SystemMessageFilter.SystemMessageFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.sortColumn = r.string();
                    break;
                case 2:
                    m.sortOrder = r.string();
                    break;
                case 3:
                    m.pageIndex = r.int32();
                    break;
                case 4:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a SystemMessageFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof SystemMessageFilter.SystemMessageFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {SystemMessageFilter.SystemMessageFilterModel} SystemMessageFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SystemMessageFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return SystemMessageFilterModel;
    })();

    return SystemMessageFilter;
})();

module.exports = $root;
